import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [clock, setClock] = useState(new Date());
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const handleLogout = () => {
    logout();
    closeMenu();
    navigate('/login');
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <nav className={`nav-bar ${scrolled ? 'nav-scrolled' : ''}`}>
      <div className="nav-inner">
        {/* Left: Logo */}
        <div className="logo">
          <Link to="/" className="logo-link" onClick={closeMenu}>
            <img
              src="/avtech-logo.jpeg"
              alt="AVTECH Logo"
              className="logo-img"
            />
            <span className="logo-text">
              AVTECH<span className="logo-dot">.</span>
            </span>
          </Link>
        </div>

        {/* Center: Nav Links */}
        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/courses" onClick={closeMenu}>Courses</Link>
          <Link to="/services" onClick={closeMenu}>Services</Link>
          <Link to="/about" onClick={closeMenu}>About</Link>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>

          {user ? (
            <div className="nav-user-container">
              <Link to="/profile" className="nav-user-profile-link" onClick={closeMenu}>
                <span className="nav-user-greeting">
                  HI, {(user.name || user.email.split('@')[0]).toUpperCase()}
                </span>
              </Link>
              <button className="nav-btn-logout" onClick={handleLogout}>
                LOGOUT
              </button>
            </div>
          ) : (
            <Link to="/login" className="nav-cta-login" onClick={closeMenu}>
              LOGIN
            </Link>
          )}
        </div>

        {/* Right: Live clock (desktop only) */}
        <div className="nav-clock" aria-hidden="true">
          <span className="nav-clock-dot" />
          <span className="nav-clock-time">
            {clock.toLocaleTimeString('en-US', { hour12: false })}
          </span>
        </div>

        {/* Hamburger */}
        <button
          className={`hamburger ${isOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
}